/**
 * @param {HTMLElement} context
 * @returns {(HTMLAnchorElement|HTMLButtonElement)[]}
 */
export function getFocusableItems(context) {
  return /** @type {(HTMLAnchorElement|HTMLButtonElement)[]} */ (
    Array.from(context.querySelectorAll(':scope > ul > li, :scope > ol > li'))
      .map((item) => item.querySelector('a, button'))
      .filter(Boolean)
  );
}

/**
 * @param {number} index
 * @param {number} length
 * @returns {number}
 */
export function wrapIndex(index, length) {
  return ((index % length) + length) % length;
}